import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { logout } from './slices/authSlice';

const PUBLIC_ROUTES = ['/', '/forgot-password', '/new-password'];
const PRIVATE_REDIRECT = '/dashboard'; 

const isTokenExpired = (token) => {
  if (!token) return true;
  const decoded = jwtDecode(token);
  return decoded.exp < Date.now() / 1000;
};

const AuthWatcher = () => {
  const access = useSelector((state) => state?.auth?.token?.access);
  const refresh = useSelector((state) => state?.auth?.token?.refresh);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
    const accessExpired = isTokenExpired(access);
    const refreshExpired = isTokenExpired(refresh);

    if (accessExpired && refreshExpired) {
      dispatch(logout());
      if (!isPublicRoute) navigate('/');
      return;
    }

    if (access && isPublicRoute) {
      navigate(PRIVATE_REDIRECT);
      return;
    }

    if (!access && !isPublicRoute) {
      navigate('/');
      return;
    }

  }, [access, refresh, location.pathname, navigate, dispatch]);

  return null;
};

export default AuthWatcher;
